// eslint-disable-next-line import/no-cycle
import * as loginApi from '@/api/login'
import { getToken, setToken, setTenantId, removeToken, setCompanyId } from '@/utils/auth'
import { authUtils } from 'blm-utils'
// import { reject } from 'bluebird'
import router from '../../router'
import * as Sentry from '@sentry/vue'

const user = {
  state: {
    token: getToken() || localStorage.TOKEN || null,
    userInfo: {},
    companySource: [], // 公司列表
    // userInfo: JSON.parse(localStorage.USERINFO || '{}')
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      localStorage.TOKEN = token
      state.token = token
    },
    SET_USER_INFO: (state, userInfo = {}) => {
      // localStorage.USERINFO = JSON.stringify(userInfo)
      state.userInfo = userInfo
      const tenantId = userInfo.tenantId || 1
      // 清理租牌相关 localStorage
      authUtils.clearHireSessionInfo()
      setTenantId(tenantId)
      Sentry.configureScope((scope) => {
        // 上报用户信息
        scope.setUser({ id: userInfo?.id })
      })
    },
    SET_COMPANY_SOURCE: (state, list) => {
      state.companySource = list
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password.trim()
      const captcha = userInfo.captcha.trim()
      return new Promise((resolve, reject) => {
        loginApi.login(username, password, captcha).then((response) => {
          const { data } = response
          const userVO = data.userVO || {}
          userVO.sessionCompanyId = data.sessionCompanyId || 0
          userVO.sessionCompanyName = data.sessionCompanyName || ''
          commit('SET_USER_INFO', userVO)
          commit('SET_TOKEN', data.token)
          setToken({ token: data.token, expiration: data.expiration })
          setCompanyId(userVO.sessionCompanyId)
          resolve()
        }).catch((error) => {
          // 清理租牌相关 localStorage
          authUtils.clearHireSessionInfo()
          reject(error)
        })
      })
    },
    SetUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // resolve(state.userInfo)
        loginApi.getInfoByToken().then((response) => {
          const { data } = response
          const userInfo = data.userVO || {}
          userInfo.sessionCompanyId = data.sessionCompanyId || 0
          userInfo.sessionCompanyName = data.sessionCompanyName || 0
          // APITable信息
          userInfo.apitableCookie = data.apitableCookie || ''
          userInfo.apitableToken = data.apitableToken || ''
          commit('SET_USER_INFO', userInfo)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    RefreshToken() {
      return new Promise((resolve, reject) => {
        loginApi.refreshToken().then((response) => {
          const { data } = response
          setToken({ token: data.token, expiration: data.expiration })
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      // 维保退出登陆
      loginApi.purchaseMallLogOut()
      return new Promise((resolve, reject) => {
        loginApi.logout().then(() => {
          commit('SET_USER_INFO', {})
          removeToken()
          localStorage.userInfo = ''
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_USER_INFO', {})
        removeToken()
        localStorage.userInfo = ''
        resolve()
      })
    },
    SwitchCompany({ commit }, { companyId }) {
      return new Promise((resolve, reject) => {
        loginApi.switchCompany(companyId)
          .then(({ code, data: { userVO: userInfo, token, expiration, sessionCompanyId } }) => {
            if (code === 1 && token) {
              userInfo.sessionCompanyId = sessionCompanyId || 0
              commit('SET_USER_INFO', userInfo)
              commit('SET_TOKEN', token)
              setToken({ token, expiration })
              setCompanyId(sessionCompanyId)
              // 防止切换公司没有当前路由的权限，所以重置到根路由
              router.replace('/')
              // 防止vuex 没有重置更新
              setTimeout(() => {
                window.location.reload(true)
              }, 500)
              resolve()
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}

export default user
